export const isInStandaloneMode = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  //@ts-ignore
  window.navigator.standalone ||
  document.referrer.includes("android-app://");
